import type { Product } from "@typings/product/product";

import { areProductsEqual } from "@helpers/products/areProductsEqual";

export const addToCart = (cartItems: Product[], newCartItems: Product[]) => {
  return newCartItems.reduce((acc, newCartItem) => {
    const existingItemIdx = acc.findIndex((ci) => areProductsEqual(ci, newCartItem));

    if (existingItemIdx !== -1) {
      return acc.map((ci, idx) => {
        return idx === existingItemIdx
          ? {
              ...ci,
              configuration: {
                ...ci.configuration,
                quantity: newCartItem.configuration.quantity,
              },
            }
          : ci;
      });
    }

    return [...acc, newCartItem];
  }, cartItems);
};
